import actions from './actions'

const initialState = {
  loading: false,
  data: {},
}

export default function update(state = initialState, action) {
  switch (action.type) {
    case actions.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case actions.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.UPDATE_ERROR:
      return {
        ...initialState,
        ...action.payload,
      }
    case actions.UPDATE_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
